var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M12.8428 -0.233122L11.8966 2.02848L12.9975 4.21897L10.7359 3.27272L8.54538 4.37363L9.49162 2.11202L8.39072 -0.0784619L10.6523 0.867784L12.8428 -0.233122Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M12.8428 -0.233122L11.8966 2.02848L12.9975 4.21897L10.7359 3.27272L8.54538 4.37363L9.49162 2.11202L8.39072 -0.0784619L10.6523 0.867784L12.8428 -0.233122Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "22.1047",
          y: "10",
          width: "1.61955",
          height: "1.61955",
          transform: "rotate(43.0104 22.1047 10)",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "22.6571",
          y: "14",
          width: "1.61955",
          height: "1.87134",
          transform: "rotate(43.0104 22.6571 14)",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M5.1835 13.7677L8.48162 13.416L9.89324 14.7328L4.2967 20.7322L3.91032 17.2551L5.46492 15.5886L3.62891 15.4342L5.1835 13.7677Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M11.1825 19.3644L11.3045 16.0498L9.89289 14.733L4.29635 20.7323L7.79192 20.8765L9.34651 19.21L9.62793 21.0309L11.1825 19.3644Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M15.8704 3.05547L21.4708 2.0723L20.8786 7.7274L12.3639 16.855L7.35565 12.1831L15.8704 3.05547Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M5.4547 6.91694L11.8063 7.41047L7.35539 12.1817L3.71305 8.78395L5.4547 6.91694Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M17.7473 18.3847L16.8142 12.0827L12.3633 16.854L16.0057 20.2517L17.7473 18.3847Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M16.0072 4.73464L18.1813 5.59883L19.1943 7.70769L18.0332 8.95237L17.0202 6.84351L14.8461 5.97932L16.0072 4.73464Z",
          fill: "#8E8E8E"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "7.35559",
          y: "12.1826",
          width: "6.84903",
          height: "1.13478",
          transform: "rotate(43.0104 7.35559 12.1826)",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M14.6025 16.1104L15.7533 17.1838",
          stroke: "#8E8E8E",
          "stroke-width": "1.1448"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M6.2594 8.32715L8.5609 10.4741",
          stroke: "#8E8E8E",
          "stroke-width": "1.1448"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M4.20733 13.6482L8.28139 13.2138L10.0251 14.8404L3.1119 22.2512L2.63462 17.956L4.55496 15.8975L2.287 15.7068L4.20733 13.6482Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M11.618 20.5613L11.7687 16.4669L10.0249 14.8403L3.11174 22.2511L7.42969 22.4291L9.35002 20.3706L9.69764 22.6198L11.618 20.5613Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M15.8704 3.05547L21.4708 2.0723L20.8786 7.7274L12.3639 16.855L7.35565 12.1831L15.8704 3.05547Z",
          fill: "#D0D0D0"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M5.4547 6.91694L11.8063 7.41047L7.35539 12.1817L3.71305 8.78395L5.4547 6.91694Z",
          fill: "#8E8E8E"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M17.7473 18.3847L16.8142 12.0827L12.3633 16.854L16.0057 20.2517L17.7473 18.3847Z",
          fill: "#8E8E8E"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M6.0266 16.3996L8.56192 13.6574L11.3041 16.1927L8.76879 18.9349L5.85222 19.2118L6.0266 16.3996Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M16.0072 4.73464L18.1813 5.59883L19.1943 7.70769L18.0332 8.95237L17.0202 6.84351L14.8461 5.97932L16.0072 4.73464Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "7.35559",
          y: "12.1826",
          width: "6.84903",
          height: "1.13478",
          transform: "rotate(43.0104 7.35559 12.1826)",
          fill: "#D0D0D0"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M14.6025 16.1104L15.7533 17.1838",
          stroke: "black",
          "stroke-width": "1.1448"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M6.2594 8.32715L8.5609 10.4741",
          stroke: "black",
          "stroke-width": "1.1448"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }